import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.common.white,
    paddingBottom: theme.spacing(4),
    '& div.rich-paragraph': {
      color: theme.palette.grey[700],
    },
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing(9),
    },
  },
  container: {
    paddingTop: theme.spacing(8),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(10),
    },
  },
  contactTitle: {
    paddingBottom: theme.spacing(5),
  },
  richText: {
    '& div.rich-paragraph': {
      marginBottom: 0,
    },
  },
  addressContainer: {
    width: '100%',
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(6),
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
      borderTop: 0,
      marginLeft: theme.spacing(9),
      padding: theme.spacing(9),
      borderLeft: `1px solid ${theme.palette.grey[300]}`,
    },
  },
}))

export default useStyles
